// src/beta/services/attributions.ts
import { betaFetch } from '@/beta/services/api';
import type { V1Attribution } from '@/beta/types/dossier';

interface Resp { version: 1; vehicle_id: string; data: { attributions: V1Attribution[] }; generated_at: string; }

export async function getAttributions(vehicleId: string) {
  const res = await betaFetch<Resp>(`/vehicles/${vehicleId}/attributions`);
  return res.data;
}
